const { axios } =
  await import(`./index.js?v=${Date.now()}`);
const { bodyLock } = await import(`./body-lock.js?v=${Date.now()}`);
import "./_commonjsHelpers.js";
import "./recommended-products.js";
class StudiosuiteStarter extends HTMLElement {
  constructor() {
    var _a;
    super();
    let gridItems = this.querySelectorAll(".starting-grid__item");
    this.getAttribute("data-section-id");
    let productTemplateId = (_a = document.querySelector(".main-product__inner--configurator")) == null ? void 0 : _a.id;
    let isOverlay = this.getAttribute("data-is-overlay") === "true" ? true : false;
    let parent = document.querySelector(".studiosuite-starter");
    let loadURL = new URL(window.location.href);
    let mainProductInner = document.querySelector(".main-product__inner");
    let inspirationButton = this.querySelector(".starting-grid__item--inspiration");
    let startFreshbutton = this.querySelector(".starting-grid__item--start-fresh");
    let hiddenStartingGridItems = this.querySelectorAll(".starting-grid__item--hidden");
    let closeButton = this.querySelector(".close-button");
    let outerElement = document.querySelector(".studiosuite-starter");
    let starterDescription = this.querySelector(".starter-description");
    let starterSubtitle = this.querySelector(".starter-subtitle");
    let starterTitle = this.querySelector(".starter-title");
    let starterBackButton = this.querySelector(".starter-button");
    let shareButton = document.querySelector(".share-button");
    let inpirationText = this.querySelector(".title-holder__inspiration-text");
    if (loadURL.searchParams.size >= 1) {
      parent.classList.add("studiosuite-starter--hidden");
    }
    const renderSections = (dom, sectionsArray) => {
      sectionsArray.forEach((section) => {
        let source = dom.querySelector(section);
        let destination = document.querySelector(section);
        destination.innerHTML = source.innerHTML;
        setTimeout(() => {
          let radio = destination.querySelector(".configurator-variant.layer--1");
          if (radio) {
            destination.querySelectorAll(".configurator-variant").forEach((selector) => {
              selector.classList.add("hidden");
            });
            destination.querySelector(".configurator-variant.layer--1").classList.remove("hidden");
          }
          document.querySelectorAll(".starting-grid__item").forEach((el) => {
            el.classList.remove("loading");
          });
        }, 500);
      });
    };
    const handleConfigurationBackInteraction = () => {
      inspirationButton.classList.add("starting-grid__item--inspiration");
      inspirationButton.classList.remove("starting-grid__item--hidden");
      startFreshbutton.classList.add("starting-grid__item--start-fresh");
      startFreshbutton.classList.remove("starting-grid__item--hidden");
      inpirationText.classList.add("title-holder__inspiration-text--hidden");
      starterDescription.classList.remove("starter-description--hidden");
      starterSubtitle.classList.remove("starter-subtitle--hidden");
      starterTitle.classList.remove("starter-title--hidden");
      starterBackButton.classList.add("starter-button--hidden");
      hiddenStartingGridItems.forEach((item) => {
        item.classList.add("starting-grid__item--hidden");
      });
      hiddenStartingGridItems.forEach((item) => {
        item.removeAttribute("data-moved-to-inspired");
      });
      document.querySelector("body").classList.remove("overflow_hidden");
    };
    const handleInspirationReveal = () => {
      inspirationButton.classList.remove("starting-grid__item--inspiration");
      inspirationButton.classList.add("starting-grid__item--hidden");
      startFreshbutton.classList.remove("starting-grid__item--start-fresh");
      startFreshbutton.classList.add("starting-grid__item--hidden");
      inpirationText.classList.remove("title-holder__inspiration-text--hidden");
      starterDescription.classList.add("starter-description--hidden");
      starterSubtitle.classList.add("starter-subtitle--hidden");
      starterTitle.classList.add("starter-title--hidden");
      starterBackButton.classList.remove("starter-button--hidden");
      hiddenStartingGridItems.forEach((item) => {
        item.classList.remove("starting-grid__item--hidden");
      });
      hiddenStartingGridItems.forEach((item) => {
        item.removeAttribute("data-moved-to-inspired");
      });
      document.querySelectorAll(".starting-grid__item").forEach((el) => {
        el.classList.remove("loading");
      });
      document.querySelector("body").classList.remove("overflow_hidden");
      window.updateSummaryPopup();
    };
    const handleKlaviyo = () => {
      var _a2;
      (_a2 = document.querySelector(".js-a2c")) == null ? void 0 : _a2.addEventListener("click", () => {
        let selectedItems = JSON.parse(sessionStorage.getItem("configuratorConfig"));
        let filteredItems = selectedItems.filter((selectedItem) => {
          return selectedItem !== null;
        });
        let filteredItemsWithResource = filteredItems.map((filteredItem) => {
          return { addedBy: "studioSUITE", urlParams: window.location.href, ...filteredItem };
        });
        _learnq.push(["track", "Added to Cart", filteredItemsWithResource]);
        console.log(_learnq);
      });
    };
    const handleConfiguratorSections = (url, e) => {
      window.history.pushState("studiosuite starting point", "", url.href);
      url.searchParams.set("sections", `${productTemplateId}`);
      sessionStorage.removeItem("configuratorConfig");
      axios.get(url.href).then((response) => {
        Object.entries(response.data).forEach(([key, value]) => {
          let dom = new DOMParser().parseFromString(value, "text/html");
          let sectionsArray = [".main-product__inner"];
          renderSections(dom, sectionsArray);
          setTimeout(() => {
            parent.classList.add("studiosuite-starter--hidden");
            mainProductInner.classList.add("main-product__inner--configurator-active");
            e.target.classList.remove("loading");
            bodyLock.unlock();
            handleKlaviyo();
            setTimeout(() => {
              let radio = document.querySelector(".configurator-variant.layer--1");
              if (radio) {
                document.querySelectorAll(".configurator-variant").forEach((selector) => {
                  selector.classList.add("hidden");
                });
                document.querySelector(".configurator-variant.layer--1").classList.remove("hidden");
              }
            }, 500);
          }, 500);
          hiddenStartingGridItems.forEach((item) => {
            item.removeAttribute("data-moved-to-inspired");
          });
        });
      });
    };
    const openGridItem = (e) => {
      hiddenStartingGridItems.forEach((item) => {
        item.removeAttribute("data-moved-to-inspired");
      });
      if (isOverlay) {
        e.target.classList.add("loading");
        let url = new URL(e.target.value === "/" ? window.location.href : `${window.location.origin}${e.target.value}`);
        if (e.target.value === "/") {
          let keys = Array.from(url.searchParams.keys());
          keys.forEach((key) => {
            url.searchParams.delete(key);
          });
        }
        if (e.target.value === "/show-inspiration") {
          handleInspirationReveal();
        } else {
          handleConfiguratorSections(url, e);
        }
      } else {
        window.location.href = e.target.value;
        parent.classList.add("studiosuite-starter--hidden");
      }
    };
    gridItems.forEach((gridItem) => {
      gridItem.addEventListener("click", (e) => {
        openGridItem(e);
        document.querySelector("body").classList.remove("overflow_hidden");
        window.scrollTo({
          top: 0,
          left: 0,
          behavior: "smooth"
        });
      });
    });
    const handleVisibilityState = () => {
      let url = new URL(window.location.href);
      if (url.searchParams.size < 1) {
        bodyLock.lock();
        parent.classList.remove("studiosuite-starter--hidden");
      } else {
        mainProductInner.classList.add("main-product__inner--configurator-active");
      }
    };
    handleVisibilityState();
    closeButton.addEventListener("click", () => {
      bodyLock.unlock();
      parent.classList.add("studiosuite-starter--hidden");
      mainProductInner.classList.add("main-product__inner--configurator-active");
    });
    outerElement.addEventListener("click", (e) => {
      if (e.target === outerElement) {
        bodyLock.unlock();
        parent.classList.add("studiosuite-starter--hidden");
        mainProductInner.classList.add("main-product__inner--configurator-active");
      }
    });
    starterBackButton.addEventListener("click", () => {
      handleConfigurationBackInteraction();
    });
    shareButton.addEventListener("click", () => {
      let copyText = shareButton.querySelector("#copy-text");
      let copyTextValue = copyText.innerHTML;
      navigator.clipboard.writeText(window.location.href);
      copyText.innerHTML = shareButton.getAttribute("data-copy-success");
      copyText.style.display = "block";
      setTimeout(() => {
        copyText.innerHTML = copyTextValue;
        copyText.style.display = "none";
      }, 2e3);
    });
    window.addEventListener("popstate", (event) => {
      handleVisibilityState();
    });
  }
}
if (!customElements.get("studiosuite-starter")) {
  customElements.define("studiosuite-starter", StudiosuiteStarter);
}
